import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
// Token layers load before app.css: palette.css holds the raw light/dark
// values, tokens.css maps them to semantic tokens (+ the legacy alias bridge),
// and app.css consumes them. Order matters — the bridge must win over any
// stale token, so the palette/token files come first.
import './styles/palette.css';
import './styles/tokens.css';
import './styles/app.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root not found');

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
